if ($('.js-second-image').length) {
	$('.js-second-image').hover(
		function() {
			$(this)
				.find('.js-item-image-front')
				.addClass('hide-image');
		},
		function() {
			$(this)
				.find('.js-item-image-front')
				.removeClass('hide-image');
		}
	);
}

createCartPopup($('.js-cart'), $('.js-cart-popup-container'));

// Create Cart Popup
function createCartPopup($link, $cartPopupContent) {
	let href = $link.attr('href');

	$(document).on('submit', '.js-product-form', function(event) {
		event.preventDefault();

		$.ajax({
			url: '/cart/add',
			data: $(this).serialize(),
			type: 'POST'
		})
			.done(function(data) {
				populateCartPopup($cartPopupContent, data);

				$('.js-cart-widget').addClass('expanded');
			})
			.fail(function(data) {
				alert('There are no more available products from this option.');
			});
	});
  
  	$(document).on('submit', '.js-product-forms', function(event) {
		event.preventDefault();

		$.ajax({
			url: '/cart/add',
			data: $(this).serialize(),
			type: 'POST'
		})
			.done(function(data) {
				populateCartPopup($cartPopupContent, data);

				$('.js-cart-widget').addClass('expanded');
			})
			.fail(function(data) {
				alert('There are no more available products from this option.');
			});
	});
  
	$.ajax({
		url: href,
		type: 'GET'
	}).done(function(data) {
		$cartPopupContent.html(
			$(data)
				.find('.js-cart-popup-get')
				.html()
		);
	});
}

// populate Cart Popup
function populateCartPopup($cartPopupContent, data) {
	const $cartTextLink = $('.cart-count');

	let cartTextNew = $(data)
		.find('.item-counter')
		.text();

	$cartTextLink.text(cartTextNew);

	let count = parseInt(cartTextNew);

	if (count <= 0) {
		$cartTextLink.addClass('hidden-count');
	} else {
		$cartTextLink.removeClass('hidden-count');
	}

	$cartPopupContent.html(
		$(data)
			.find('.js-cart-popup-get')
			.html()
	);
}

$('.js-toggle-btn').on('click', function(e) {
	e.preventDefault();
	const $this = $(this);
	const btnId = $this.data('id');
	const btnClass = $this.data('class');

	$(btnId).toggleClass(btnClass);
});

$(document).on('click', '.quantity-main .quantity__controls', function() {
	const $this = $(this);
	const qtyInput = $this.parent().find('.js-total-quantity');
	const qtyInputId = qtyInput.data('vid');
	const itemPrice = qtyInput.data('price');
	const qtyInputLine = qtyInput.data('line');
	let qtyInputVal = qtyInput.val();
	qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

	if ($this.hasClass('js-plus-quantity')) {
		qtyInputVal++;
		qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
	} else {
		qtyInputVal--;
		qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
	}

	qtyInput.val(qtyInputVal);
	changeProductQuantity(qtyInputVal, qtyInputLine, $('.js-cart-popup-container'));
});

$(document).on('change', '.js-total-quantity', function() {
	const $this = $(this);
	let qtyInputVal = $this.val();
	let qtyInputLine = $this.data('line');

	changeProductQuantity(qtyInputVal, qtyInputLine, $('.js-cart-popup-container'));
});

function changeProductQuantity(increaseNumber, selectLine, $cartPopupContent) {
	$.ajax({
		url: '/cart/change?line='.concat(selectLine, '&amp;quantity=').concat(increaseNumber),
		beforeSend: function beforeSend() {
			$('.js-cart-widget').addClass('loads');
		},
		complete: function complete() {
			$('.js-cart-widget').removeClass('loads');
		}
	}).done(function(data) {
		populateCartPopup($cartPopupContent, data);
	});
}

// activate checkout button in ajax cart
$(document).on('click', '.js-activate-checkout', function() {
	$('.js-checkout-btn').trigger('click');
});
